interface RailStateBlockProps {
  title: string;
  message: string;
  tone?: 'error' | 'neutral';
  onRetry?: () => void;
}

export function RailStateBlock({ title, message, tone = 'neutral', onRetry }: RailStateBlockProps) {
  return (
    <div className="mt-3 rounded-md border border-dashed border-line-strong p-4 text-[13px] leading-[1.5] text-subtle">
      <strong
        className={`mb-1 block font-semibold ${tone === 'error' ? 'text-red-300' : 'text-fg'}`}
      >
        {title}
      </strong>
      {message}
      {onRetry != null && (
        <>
          <br />
          <button
            type="button"
            onClick={onRetry}
            className="mt-2.5 rounded-md border border-line-strong bg-panel-2 px-3 py-1.5 text-xs text-fg"
          >
            Retry
          </button>
        </>
      )}
    </div>
  );
}
